import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/tick.svg")